import ShareBox from './ShareBox';

export default ShareBox;